import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../services/auth.service';
import { RouterPathConfig } from '../constants/router-path.config';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
    constructor(public router: Router, private authService: AuthService, private cookies: CookieService, @Inject(PLATFORM_ID) private platformId: Object) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const isAuthenticated = this.authService.isUserAuthenticated();
        const prefix = environment.prefix;

        if (!isAuthenticated && state.url !== '/' + RouterPathConfig.LOGIN_PATH) {
            window.location.href = prefix + '/' + RouterPathConfig.LOGIN_PATH;
            return false;
        }

        if (isAuthenticated && state.url === '/' + RouterPathConfig.LOGIN_PATH) {
            window.location.href = prefix;
        }
        return true;
    }
}
